module.exports = __webpack_public_path__ + "static/utah-festival-opera-87ad1edd7d6932db27c399d492ee6075.jpg";